export enum StorageKey {
  TOKEN = 'token',
}
